import _ from 'lodash';
import Typography from '@mui/material/Typography';
import { parseGutenbergReact, parseParagraphReact } from '@/api/global';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import DynamicBreadcrumbs from '@/components/01_atoms/DynamicBreadcrumbs';
import { visuallyHidden } from '@mui/utils';

let layoutOpts = {
  titleBgWide: false,
  titleBgClr: 'warning.dark',
  mainBgClr: '',
  // mainBgImg: '/images/bg-c-n-page.jpg',
  sideBgClr: false,
  topBgClr: false,
};

const useStyles = makeStyles((theme) => ({
  root: {
    '& .bannerButtonWrapper .MuiButton-contained': {
      padding: '10px 20px',
    },
  },
  title: {
    fontWeight: '700',
    [theme.breakpoints.down('lg')]: {
      fontSize: '30px',
      lineHeight: '36px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '20px',
      lineHeight: '24px',
    },
  },
  description: {
    fontFamily: 'Lato',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '36px',
    [theme.breakpoints.down('lg')]: {
      fontSize: '16px',
      lineHeight: '24px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
  breadcrumbContainer: {
    padding: '0 78px',
    'maxWidth': '1400px',
    'margin': '0 auto',
    [theme.breakpoints.down('lg')]: {
      padding: '0 20px',
    },
  },
  container: {
    padding: '0 78px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    'maxWidth': '1400px',
    'margin': '0 auto',
    [theme.breakpoints.down('lg')]: {
      padding: '0 20px',
    },
  },
  itemDescription: {
    fontFamily: 'Lato',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: '400',
    textAlign: 'center',
    lineHeight: '27px',
    [theme.breakpoints.down('lg')]: {
      fontSize: '14px',
      lineHeight: '20px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '12px',
    },
  },
  imageCarouselContainer: {
    width: '740px',
    height: '500px',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      height: '300px',
    },
  },
}));

const ProgramPagesLayout = (props) => {
  const classes = useStyles();
  // const actionElementClass = useActionElementStyles().actionElement;

  let { node } = props;
  if (!node) {
    return null;
  }

  if (node?.bgSlider?.length > 0) {
    layoutOpts.topBgClr = node.bgSlider;
  }

  let {
    title,
    hideTitle,
    body,
    body_json,
    para,
    paraTop,
    slides,
  } = node;

  const topbar = (
    <>
      {paraTop?.length > 0 &&
      <Typography paragraph component={`div`} className={`programs-region-top`}>
        {
          paraTop.map((para_ent, key) => {
            return parseParagraphReact(key, para_ent, slides);
          })
        }
      </Typography>
      }
      {Array.isArray(node?.breadcrumbs) && node?.breadcrumbs?.length > 0 &&
      <Box className={classes.breadcrumbContainer}>
        <DynamicBreadcrumbs/>
      </Box>
      }
    </>
  );

  return (
    <div className={classes.root}>
      <main style={{ paddingBottom: '100px' }}>

        {topbar &&
        <Box>
          <Container className="alignfull">
            <Grid container>
              <Grid item xs={12} className={''}>
                {topbar}
              </Grid>
            </Grid>
          </Container>
        </Box>
        }

        <div className={'main-content-begins'}>
          <Box pb="2rem" className={classes.container}>
            <Box style={{ width: '100%' }}>
              {title && !hideTitle &&
              <Typography variant="h1"
                          className={`page-title ${classes.title}`}>
                {title}
              </Typography>
              }
              {title && hideTitle &&
              <Typography variant="h1" style={visuallyHidden}
                          className={`MuiTypography-srOnly`}>{title}</Typography>
              }
            </Box>
            <Box style={{ width: '100%' }}>
              <Grid container spacing={4}>
                <Grid item xs={12} className={`main-body`}>
                  <>
                    {(body_json?.json?.length > 0) &&
                    body_json.json.map((block, key) => {
                      return parseGutenbergReact(key, block);
                    })
                    }
                    {body?.length > 0 && _.isEmpty(body_json) &&
                    <Typography paragraph component={`div`}>
                      <div dangerouslySetInnerHTML={{ __html: body }}></div>
                    </Typography>
                    }
                    {para?.length > 0 &&
                    <Typography paragraph component={`div`}>
                      {
                        para.map((para_ent, key) => {
                          return parseParagraphReact(key, para_ent, slides);
                        })
                      }
                    </Typography>
                    }
                  </>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </div>
      </main>
    </div>
  );
};

export default ProgramPagesLayout;
